import * as React from "react"

function ChevronDown(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.64 5.74" {...props}>
      <g data-name="Capa 2">
        <path
          fill="none"
          stroke="#003da6"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2px"
          data-name="Capa 1"
          d="M1 1.13L4.73 4.74 8.64 1"
        />
      </g>
    </svg>
  )
}

export default ChevronDown
